<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <span style="margin-left:5px;">快捷回复设置</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div class="header-id" style="margin-bottom:20px;">
          <div style="margin-bottom:40px;">
              <span style="font-size:15px;margin-left:20px;">快捷回复： </span>
            <el-input v-model="replyContent"   style="width:216px;margin-right:20px"></el-input>
            <el-button type="primary" @click="search"  icon="el-icon-search">搜索</el-button>
            <el-button type="success" @click="add" >新增</el-button>
            <el-button type="warning" @click="reset" >重置</el-button>
          </div>
        </div>
        <div>
          <el-table 
          border 
          :default-sort="{prop:'usage_frequency',order:'descending'}"
          v-loading="listLoading" 
          :data="tableData" 
          @sort-change="changeSort"
          style="width: 100%"
          >
            <el-table-column key = "1" prop="sort_number" label="序号" sortable @sort-method="changeSort" />
            <el-table-column key = "2" prop="content" label="内容" />
            <el-table-column key = "3" prop="usage_frequency" label="使用次数" sortable @sort-method="changeSort" />
            <el-table-column label="操作" align="center" >
              <template slot-scope="scope">
                <el-button size="mini" type="primary" icon="el-icon-edit" @click="edit(scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" icon="el-icon-delete" @click="del(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            v-show="total>0"
            :total="total"
            :page.sync="page"
            :limit.sync="limit"
            @pagination="handleList"
          />
          <el-dialog :title="popupTitle " width="450px" center :visible.sync="dialogFlag" :close-on-click-modal= addControl @close='closeDialog'>
            <div>
               <span>内容： </span>
              <el-input v-model="editContent"   style="width:216px;margin-right:20px"></el-input>
            </div>
            <div style="margin-top:10px;">
               <span>序号： </span>
              <el-input v-model="editNumber"   type='number' @input = "filterReply" style="width:216px;margin-right:20px"></el-input>
            </div>
            
            <div slot="footer" class="dialog-footer">
              <el-button @click="remove">取 消</el-button>
              <el-button type="primary" @click="sure">确 定</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from "@/components/pagination/index";
import {
  fastReply,
  editGet,
  editSubmit,
  deleteReply,
  addReply,
} from "@/api/work_sn.js";
export default {
  components: { Pagination },
  name: "work_reply",
  data() {
      return {
          replyContent:"",
          tableData:[],
          listLoading:false,
          page:1,
          limit:10,
          total:2,
          dialogFlag:false,
          editContent:"",
          editNumber:"",
          editId:"",
          popupTitle:"",
          // 添加数据的缓存。
          keepEditContent:"",
          keepEditNumber:"",
          addCheck:0,

          form:{
              limit:10,
              page:1,
              content:"",
              order_field:1,
              order_type:1,
          },
          check:"",
      }
  },
  created() {
    this.newestData();
  },
   computed:{
    addControl(){
      let item = true;
      if(this.popupTitle  == "添加"){
        item = false;
      }
      return item;
    }
  },
  methods: {
     add() {
       this.popupTitle = "添加";
       this.dialogFlag = true;
       this.editContent = "";
       this.editNumber = " ";
       if(this.addCheck == 1){
          this.editContent = this.keepEditContent;
          this.editNumber = this.keepEditNumber;
        }
       this.check = 0;
     },
    closeDialog(){
      if(this.popupTitle  == "添加" && (this.addCheck == 0 || this.addCheck == 1)){
          this.keepEditContent = this.editContent;
          this.keepEditNumber = this.editNumber;
          this.addCheck = 1;
      }
      if(this.popupTitle  == "添加" && this.addCheck == 2){
            this.addCheck = 0;
            this.keepEditContent = "";
            this.keepEditNumber = " ";
      }
    },
    reset() {
         this.replyContent = "";
         this.form.content = "";
         this.form.page = 1;
         this.form.limit = 10 ;
         this.limit = 10 
         this.page = 1;
         this.newestData();
     },
     edit(row) {
         this.popupTitle = "编辑";
         this.dialogFlag = true;
         this.check = 1;
         this.editId = row.id;
         this.editNumber = row.sort_number
         this.editContent = row.content;
     },
     changeSort(column){
        this.listLoading = true;
        if(column.prop === "sort_number"){
          this.form.order_field = 1
        }else if (column.prop === "usage_frequency"){
          this.form.order_field = 0
        }
        if(column.order === "ascending") {
           this.form.order_type = 1
         }else if (column.order === "descending"){
           this.form.order_type = 0
         }
        fastReply(this.form)
        .then(response => {
         let data = []
         for(let item of response.data.data.data){
           let m={
             id:"",
             content:"",
             usage_frequency:"",
             sort_number:""
           }
           m = item
           m.usage_frequency = Number(m.usage_frequency) 
           m.sort_number = Number(m.sort_number) 
           data.push(m)
         }
         this.tableData = data;
         this.total = response.data.data.total;
         setTimeout(() => {
                    this.listLoading = false;
                }, 0.5*1000);
       })
       .catch(error => {
         this.listLoading = false;
       })
     },
     del(row) {
       let data = {
         id:""
       }
       data.id=row.id;
       deleteReply(data)
        .then(response => {
          this.newestData();
        })
        .catch(error => {})
     },
     remove() {
       this.dialogFlag = false
     },
     sure() {
      if(this.check === 0) {
          let data ={
            content:"",
            sort_number:""
          }
          this.listLoading = true;
          data.content = this.editContent;
          data.sort_number = this.editNumber
          addReply(data)
           .then(response => {
             this.addCheck = 2;
             this.newestData();
           })
           .catch(error => {})
      }
      else if(this.check === 1) {
         let data ={
            sort_number:"",
            content:"",
            id:" ",
          }
          this.listLoading = true;
          data.sort_number = this.editNumber;
          data.content = this.editContent;
          data.id = this.editId 
          editSubmit(data)
           .then(response => { 
             this.newestData();
           })
           .catch(error => {})
      }
      this.dialogFlag = false
     },

    handleList() {
      this.form.page = this.page;
      this.form.limit = this.limit;
      this.newestData()
    },
    search() {
      this.form.page = 1;
      this.page = 1;
      if(this.replyContent == "") {
         this.form.content = "";
         this.form.limit = 10;
         this.newestData();
         return;
      }
        this.listLoading = true;
        this.form.content = this.replyContent;
        this.newestData();
        this.listLoading = false;
    },
    filterReply(){
      if(this.editNumber.toString().includes('-')){
        this.editNumber = 0
      }
    },
     newestData() {
      this.listLoading = true;
      this.form.order_field = 0
      this.form.order_type = 0
      fastReply(this.form)
       .then(response => {
         let data = []
         for(let item of response.data.data.data){
           let m={
             id:"",
             content:"",
             usage_frequency:"",
             sort_number:""
           }
           m = item
           m.usage_frequency = Number(m.usage_frequency) 
           m.sort_number = Number(m.sort_number) 
           data.push(m)
         }
         this.tableData = data;
         this.total = response.data.data.total;
         setTimeout(() => {
                    this.listLoading = false;
                }, 0.5*1000);
       })
       .catch(error => {
         this.listLoading = false;
       })
    },
   }
}
</script>

<style >
.title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 20px;
}
.header-id {
  font-size: 14px;
  overflow: hidden;
}
</style>